import React from 'react';
import T from 'prop-types';
import Icon from '../icon/Icon';
import routes from '../../routes/constants';
export var BRANDS = {
    INSTAGRAM: 'instagram',
    YOUTUBE: 'youtube',
    TWITTER: 'twitter',
    FACEBOOK: 'facebook',
    LINKEDIN: 'linkedin'
};
var SocialMedia = function(props) {
    var brand = props.brand;
    return /*#__PURE__*/ React.createElement("a", {
        href: routes.larkiSocialMedia[brand],
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: brand
    }));
};
SocialMedia.propTypes = {
    brand: T.string
};
export default SocialMedia;
